import PublicLayout from "../../modules/ui/components/PublicLayout";
import React from "react";
import PackageWizard from "../../modules/package/components/form/PackageWizard";

const PagePackage = () => {
    return (
        <PublicLayout>
            <div className={`nc-CheckOutPage`} data-nc-id="CheckOutPage">
                {/* Banner fullwidth */}
                <div className="w-full">
                    <PackageWizard />
                </div>
            </div>
        </PublicLayout>
    );
}

export default PagePackage;
